import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { Box, Typography, Card, Stack, Grid } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { settingsMenu } from "../../Helpers/constants";
import DiamondPremiumImg from "../../components/DiamondPremiumImg";

const Settings = () => {
  const { open } = useOutletContext();
  const navigate = useNavigate();

  const handleSettingsClick = (path) => {
    if (path === "email-templates") {
      navigate(`/settings/${path}`);
    }
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        p: 3,
        width: open ? "calc(100% - 240px)" : "calc(100% - 100px)",
        ml: open ? "240px" : "100px",
        transition: "margin 0.3s ease",
        height: "100vh",
        display: "flex",
        backgroundColor: "#f9f9f9",
      }}
    >
      <Box
        mt={10}
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fff",
          borderRadius: 2,
          overflow: "hidden",
          height: "calc(100% - 73px)",
          marginLeft: open ? "" : "1em",
        }}
      > 
        {/* HEADER */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderBottom: "1px solid #EFEDEF",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: { xs: "16px", md: "20px" },
            }}
          >
            Settings
          </Typography>
        </Box>
        {/* BODY */}
        <Box
          sx={{
            px: 3,
            py: 2,
          }}
        >
          <Grid
            container
            //   spacing={{ xs: 2, md: 1.5 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {Object.keys(settingsMenu).map((key) => {
              return (
                <Card
                  sx={{
                    boxShadow: "none",
                    borderRadius: "10px",
                    border: "1px solid #DEDEDE",
                    width: 350,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#000000",
                      padding: "10px 16px",
                      background:
                        "linear-gradient(90deg, #F1F5FB 0%, #F9F1F3 100%)",
                    }}
                  >
                    {key}
                  </Typography>
                  <Stack sx={{ padding: 1.5 }} spacing={1.5}>
                    {settingsMenu[key].map((item) => (
                      <Stack
                        sx={{
                          border: "1px solid #E1E1E1",
                          background: "#F8F8F8",
                          cursor: "pointer",
                          padding: "7px 12px",
                          color: "var(--secondary-text-color)",
                          fontWeight: 500,
                          height: "46px",
                          borderRadius: "8px",
                        }}
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        onClick={() => handleSettingsClick(item.path)}
                        key={item?.id}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#1D1D1D",
                            display: "flex",
                          }}
                          fontWeight={500}
                        >
                          {item.icon}
                          {item?.title}
                        </Typography>
                        {item?.title === "Email Templates" ? (
                          <KeyboardArrowRightIcon
                            fontSize="small"
                            sx={{ color: "#1D1D1D" }}
                          />
                        ) : (
                          <DiamondPremiumImg marginRight={0.5} height={30} />
                        )}
                      </Stack>
                    ))}
                  </Stack>
                </Card>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default Settings;
